import { businessToday } from '@lib/helpers/business-day'

/**
 * Today and the calendar year where the business works. The day itself is
 * shared with the API. An evening in Lubbock is already the next day in UTC,
 * so "today" taken from `toISOString` marks a season started a day early.
 */
export { businessToday }

/** The calendar year where the business works. */
export function businessYear(now: Date = new Date()): number {
  return Number(businessToday(now).slice(0, 4))
}
